export const ShopSubCategory = {
    'shop_sub_category': 'Shop Sub Category',
    'name': 'Name',
    'description': 'Description',
    'status': 'Status',
    'shop_category': 'Shop Category',
    'table_name': 'SHOP SUB CATEGORY',
    'table_category': 'SHOP CATEGORY',
    'table_status': 'STATUS',
    'table_description': 'DESCRIPTION',
    'error_name': 'Shop Sub Category Name is required',
    'error_category': 'Shop Category is required',
    'error_status': 'Status is required',
    'error_description': 'Description is required',
}
